import React, { Fragment } from 'react';
import { string, func, bool, array, node } from 'prop-types';
import cn from 'classnames';
import { Icon } from 'semantic-ui-react';
import Svg from 'react-inlinesvg';
import { getLinkProps, LinkComponent } from '../../utils';
import { kickoutIcon } from '../../images';
import ComingSoon from './ComingSoon';

import { Backdrop } from './Menu.css';
import { StyledMenuList, StyledMenuLink, StyledSubmenu } from './MenuItem.css';

const MenuItem = ({
  title,
  url,
  onClick,
  qa,
  icon,
  subItems = [],
  closeSubmenu,
  showSubMenu = false,
  disabled = false,
  comingSoon = false,
  active = false,
  mobile = false,
  header = false,
  external = false,
  tabletMenuVisible = false,
  children
}) => {
  const isDisabled = disabled || comingSoon;
  return (
    <StyledMenuList data-testid="menu-item-list-item-container">
      <StyledMenuLink
        data-qa={qa}
        {...getLinkProps(url, external)}
        onClick={!isDisabled ? onClick : undefined}
        exact
        data-testid="menu-item-list-item"
        activeClassName="menuitem__link--active"
        className={cn('menuitem__link', {
          'menuitem__link--root': !!icon,
          'menuitem__link--active': active, // for submenu
          'menuitem__link--disabled': isDisabled,
          'menuitem__link--hassub': !!subItems.length
        })}
      >
        {icon && (
          <Svg
            src={icon}
            active={active}
            disabled={isDisabled}
            data-testid="menu-item-icon"
            className="menuitem__icon"
          />
        )}
        <header>
          <strong className="menuitem__title">
            {header && (
              <Icon
                name="angle left"
                color="green"
                data-testid="menu-item-back"
              />
            )}
            {title}
          </strong>
          {comingSoon && <ComingSoon disabled={isDisabled} />}
        </header>
        {external && <Svg src={kickoutIcon} className="menuitem__external" />}
        {subItems.length > 0 && (
          <Icon name="angle right" data-testid="sub-menu-arrow-icon" />
        )}
      </StyledMenuLink>

      {showSubMenu && !mobile && subItems.length > 0 && (
        <Fragment>
          <StyledSubmenu data-testid="menu-item-sub-menu">
            <header>
              <Icon name="close" onClick={closeSubmenu} />
            </header>
            <ul>
              {subItems.map(({ title, url, external, comingSoon, qa }, idx) => (
                <li key={`${title}${idx}`}>
                  <LinkComponent
                    url={url}
                    external={external}
                    onClick={closeSubmenu}
                    data-qa={qa}
                  >
                    {title}
                    {external && (
                      <Svg src={kickoutIcon} className="menuitem__external" />
                    )}
                  </LinkComponent>
                  {comingSoon && <ComingSoon />}
                </li>
              ))}
            </ul>
          </StyledSubmenu>
          {/* avoid open multiple backdrop on small screen */}
          <Backdrop
            active={!tabletMenuVisible}
            onClickOutside={closeSubmenu}
            data-testid="menu-item-backdrop"
          />
        </Fragment>
      )}
      {children}
    </StyledMenuList>
  );
};

MenuItem.propTypes = {
  active: bool,
  url: string,
  showSubMenu: bool,
  closeSubmenu: func,
  disabled: bool,
  header: bool,
  icon: string,
  comingSoon: bool,
  mobile: bool,
  onClick: func,
  subItems: array,
  title: string.isRequired,
  external: bool,
  qa: string,
  tabletMenuVisible: bool,
  children: node
};

export default MenuItem;



// WEBPACK FOOTER //
// ./src/components/Menu/MenuItem.js